import InitialState from "../InitialState";
import * as types from "./ActionTypes";

export default function IssueReducer(state = InitialState.issues, action) {
    switch(action.type) {
        case types.UPDATE_ISSUE_CONTEXT:
            return {
                context: action.payload.data.context,
                context_id: action.payload.data.context_id
            }
    
        default:
            return state
    }
}